<template>
    <div class="billing-wrap">
        <el-tabs v-model="activeName">

            <el-tab-pane label="费用充值" name="cost">
                <cost v-if="activeName=='cost'"></cost>
            </el-tab-pane>

             <el-tab-pane label="单价修改" name="price">
                <pricerecord v-if="activeName=='price'"></pricerecord>
            </el-tab-pane>
            
            <el-tab-pane label="消息通知" name="msg">
                <msgrecord v-if="activeName=='msg'"></msgrecord>
            </el-tab-pane>

            <el-tab-pane label="设备操作" name="device">
                <relayrecord v-if="activeName=='device'"></relayrecord>
            </el-tab-pane>

             <el-tab-pane label="设备管理" name="manage">
                <siteconfig v-if="activeName=='manage'"></siteconfig>
            </el-tab-pane>

            <el-tab-pane label="报警记录" name="alarm">
                <alarmrecord v-if="activeName=='alarm'"></alarmrecord>
            </el-tab-pane>

        </el-tabs>
        <!--充值进度-->
        <process />
    </div>
</template>
<script>
import Cost from "./Cost"

export default {
    name:"billing",
    data(){
        return {
            activeName:"cost"
        }
    },
    components:{
        cost:Cost,
        // failed:()=>import('./Failed.vue'), // 错误充值记录
        pricerecord:()=>import("./PriceRecord.vue"), // 单价修改
        process:()=>import("./Proccess.vue"), // 充值进度模块
        msgrecord:()=>import("./MsgRecord.vue"), // 消息发送记录
        relayrecord:()=>import("./RelayRecord"), // 设备操作记录
        alarmrecord:()=>import("./AlarmRecord"), // 报警记录
        siteconfig:()=>import("./SiteConfig.vue"), // 设备管理
    }
}
</script>

<style lang="scss">
.billing-wrap{
    padding: 10px;
}

/** 充值对话框 */
.bill-dialog{
    .el-dialog{
        width: fit-content;

        .el-dialog__header{
            padding: 10px 20px 20px;

            .el-dialog__headerbtn{
                top: 10px;
                right: 10px;
            }
        }
        .el-dialog__body{
            padding:0 15px 10px 15px;
        }
    }
}
</style>